import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Section } from './ui/Section';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Me sirve si tengo pocos seguidores?',
  a: 'Sí. El método prioriza acciones pequeñas (DM, link, lead) donde un público pequeño puede convertir. No necesitas viralidad masiva para generar ingresos.'
}, {
  q: '¿Tengo que mostrar mi cara?',
  a: 'No es obligatorio. Puedes hacerlo con demo, pantalla, texto y voz. (Mostrar cara acelera confianza, pero no es requisito indispensable).'
}, {
  q: '¿Y si todavía no sé qué vender?',
  a: 'Por eso el ebook incluye el mapa de monetización y cómo elegir 1 ruta por 30 días para validar tu oferta.'
}, {
  q: '¿En qué formato viene?',
  a: 'PDF descargable. Lo puedes leer en tu celular, tablet o computadora. Acceso inmediato después del pago.'
}, {
  q: '¿Cuánto tiempo toma ver resultados?',
  a: 'Si aplicas el plan de 30 días con consistencia, puedes ver tus primeras conversiones en las primeras 2-3 semanas. No es magia, es sistema.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <Section className="bg-[#0a0a0a]" data-id="element-42">
      <h2 className="text-3xl font-bold text-white mb-12 text-center" data-id="element-43">
        Preguntas típicas
      </h2>
      <div className="max-w-2xl mx-auto space-y-3" data-id="element-44">
        {faqs.map((faq, idx) => <div key={idx} className="glass-card overflow-hidden" data-id="element-45">
            <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full flex items-center justify-between p-6 text-left hover:bg-white/[0.02] transition-colors" data-id="element-46">
              <span className="font-bold text-white" data-id="element-47">{faq.q}</span>
              <ChevronDown className={`text-[#14b8a6] transition-transform duration-300 shrink-0 ml-4 ${openIndex === idx ? 'rotate-180' : ''}`} data-id="element-48" />
            </button>
            <AnimatePresence data-id="element-49">
              {openIndex === idx && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} className="overflow-hidden" data-id="element-50">
                  <div className="px-6 pb-6 text-gray-400 border-t border-white/[0.04] pt-4" data-id="element-51">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
}